(() => {
  const initialize = (root) => {
    if (root.dataset.pnxInitialized) return;
    root.dataset.pnxInitialized = 'true';
    root.classList.add('pnx-js');

    root.querySelectorAll('.pnx-view-toggle').forEach((group) => { group.hidden = false; });

    const immersiveFilters = root.querySelector('.pnx-immersive-filters');
    if (immersiveFilters) {
      immersiveFilters.hidden = false;
      const cards = [...root.querySelectorAll('[data-pnx-immersive-case]')];
      const status = root.querySelector('[data-pnx-immersive-status]');
      const setFilter = (button) => {
        const value = button.dataset.pnxImmersiveFilter;
        root.querySelectorAll('[data-pnx-immersive-filter]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });
        let visible = 0;
        cards.forEach((card) => {
          const show = value === 'all' || card.dataset.pnxCategory === value;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (status) status.textContent = `${button.textContent.trim()}：${visible}例を表示しています。`;
      };
      const active = immersiveFilters.querySelector('[data-pnx-immersive-filter][aria-pressed="true"]');
      if (active) setFilter(active);
    }

    root.addEventListener('click', (event) => {
      const filterButton = event.target.closest('button[data-pnx-immersive-filter]');
      if (filterButton && root.contains(filterButton)) {
        const cards = [...root.querySelectorAll('[data-pnx-immersive-case]')];
        const status = root.querySelector('[data-pnx-immersive-status]');
        const value = filterButton.dataset.pnxImmersiveFilter;
        root.querySelectorAll('[data-pnx-immersive-filter]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === filterButton));
        });
        let visible = 0;
        cards.forEach((card) => {
          const show = value === 'all' || card.dataset.pnxCategory === value;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (status) status.textContent = `${filterButton.textContent.trim()}：${visible}例を表示しています。`;
        return;
      }

      const specLink = event.target.closest('a[data-pnx-spec-link]');
      if (specLink && root.contains(specLink) && specLink.hash) {
        let target = null;
        try {
          target = root.querySelector(specLink.hash);
        } catch (_) {
          target = null;
        }
        if (target) {
          root.querySelectorAll('.pnx-immersive-spec.is-target').forEach((item) => item.classList.remove('is-target'));
          if (target.matches('details[data-pnx-immersive-spec-target]')) {
            target.open = true;
            target.classList.add('is-target');
            const summary = target.querySelector('summary');
            window.requestAnimationFrame(() => summary?.focus({ preventScroll: true }));
          } else if (target.matches('[data-pnx-spec-target]')) {
            window.requestAnimationFrame(() => target.focus({ preventScroll: true }));
          }
        }
        return;
      }

      const button = event.target.closest('button[data-pnx-view]');
      if (!button || !root.contains(button)) return;
      const card = button.closest('[data-pnx-menu]');
      const closed = button.dataset.pnxView === 'closed';
      const template = card.querySelector('template[data-pnx-closed]');
      if (closed && template) {
        template.replaceWith(template.content.cloneNode(true));
      }
      card.classList.toggle('pnx-is-closed', closed);
      card.querySelectorAll('button[data-pnx-view]').forEach((item) => {
        const selected = item === button;
        item.classList.toggle('pnx-is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
    });

    if (location.hash) {
      try {
        const target = root.querySelector(location.hash);
        if (target?.matches('details[data-pnx-immersive-spec-target]')) target.open = true;
      } catch (_) {
        // Ignore malformed hashes; native navigation remains available.
      }
    }
  };

  const scan = (scope) => {
    if (scope.matches?.('[data-pnx-series-feature]')) initialize(scope);
    scope.querySelectorAll?.('[data-pnx-series-feature]').forEach(initialize);
  };

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
